/**
 * SH-502: Size Chart Modal Component
 * Gestisce l'apertura e chiusura del modal della tabella taglie
 */
(function() {
  'use strict';

  let modal = null;
  let overlay = null;
  let closeButtons = [];
  let openButtons = [];
  let previousFocus = null;
  let dropdown = null;
  let imageContainer = null;
  let imagePlaceholder = null;

  function handleEscape(event) {
    if (event.key === 'Escape' && modal && !modal.hasAttribute('hidden')) {
      closeModal();
    }
  }

  function openModal() {
    if (!modal) return;

    // Salva il focus corrente
    previousFocus = document.activeElement;

    // Mostra il modal
    modal.removeAttribute('hidden');

    // Blocca lo scroll del body
    document.body.style.overflow = 'hidden';

    // Focus sul pulsante di chiusura per accessibilità
    const closeButton = modal.querySelector('.size-chart-close');
    if (closeButton) {
      setTimeout(() => closeButton.focus(), 100);
    }

    // Dispatch evento personalizzato
    modal.dispatchEvent(new CustomEvent('sizechart:open'));
  }

  function closeModal() {
    if (!modal || modal.hasAttribute('hidden')) return;

    // Nascondi il modal
    modal.setAttribute('hidden', '');

    // Ripristina lo scroll del body
    document.body.style.overflow = '';

    // Ripristina il focus precedente
    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }

    // Reset dropdown alla selezione iniziale
    if (dropdown) {
      dropdown.value = '';
      updateImageDisplay(null);
    }

    // Dispatch evento personalizzato
    modal.dispatchEvent(new CustomEvent('sizechart:close'));
  }

  function updateImageDisplay(imageUrl) {
    if (!imageContainer) return;

    // Trova tutte le immagini esistenti (sia quella iniziale che quella dinamica)
    const existingImages = imageContainer.querySelectorAll('[data-sizechart-image]');
    const dynamicImage = imageContainer.querySelector('[data-sizechart-dynamic-image]');
    
    if (!imageUrl) {
      // Nascondi tutte le immagini dinamiche
      if (dynamicImage) {
        dynamicImage.style.display = 'none';
      }
      // Mostra placeholder se non ci sono immagini iniziali
      if (imagePlaceholder && existingImages.length === 0) {
        imagePlaceholder.style.display = 'block';
      } else if (existingImages.length > 0) {
        // Mostra l'immagine iniziale se esiste
        existingImages.forEach(img => {
          if (!img.hasAttribute('data-sizechart-dynamic-image')) {
            img.style.display = 'block';
          }
        });
      }
      return;
    }

    // Nascondi placeholder
    if (imagePlaceholder) {
      imagePlaceholder.style.display = 'none';
    }

    // Nascondi tutte le immagini iniziali
    existingImages.forEach(img => {
      if (!img.hasAttribute('data-sizechart-dynamic-image')) {
        img.style.display = 'none';
      }
    });

    const selectedText = dropdown.options[dropdown.selectedIndex].text;

    // Se esiste già un'immagine dinamica, aggiorna il src
    if (dynamicImage) {
      dynamicImage.src = imageUrl;
      dynamicImage.style.display = 'block';
      dynamicImage.alt = selectedText;
    } else {
      // Crea nuova immagine dinamica
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = selectedText;
      img.className = 'size-chart-image';
      img.setAttribute('data-sizechart-image', '');
      img.setAttribute('data-sizechart-dynamic-image', '');
      img.loading = 'lazy';
      img.style.display = 'block';
      
      // Gestisci errori di caricamento
      img.onerror = function() {
        if (imagePlaceholder) {
          imagePlaceholder.style.display = 'block';
          const placeholderText = imagePlaceholder.querySelector('.size-chart-unavailable');
          if (placeholderText) {
            placeholderText.textContent = 'Immagine non trovata';
          }
        }
        img.style.display = 'none';
      };

      imageContainer.appendChild(img);
    }
  }

  function handleDropdownChange() {
    const selectedOption = dropdown.options[dropdown.selectedIndex];
    const imageUrl = selectedOption ? selectedOption.getAttribute('data-url') : null;
    updateImageDisplay(imageUrl);
  }

  function init() {
    // Trova il modal
    modal = document.querySelector('[data-sizechart-modal]');
    if (!modal) return;

    // Trova overlay e pulsanti di chiusura
    overlay = modal.querySelector('.size-chart-overlay');
    closeButtons = Array.from(modal.querySelectorAll('[data-sizechart-close]'));
    
    // Trova dropdown e container immagine
    dropdown = modal.querySelector('[data-sizechart-selector]');
    imageContainer = modal.querySelector('.size-chart-image-container');
    imagePlaceholder = modal.querySelector('[data-sizechart-image-placeholder]');
    
    // Trova tutti i link/pulsanti che aprono il modal
    openButtons = Array.from(document.querySelectorAll('[data-sizechart-open]'));

    // Aggiungi event listeners per i pulsanti con data attribute
    openButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        openModal();
      });
    });

    // Intercetta i link che puntano a /pages/tabella-taglie nella product page
    const sizeChartLinks = Array.from(document.querySelectorAll('a[href*="/pages/tabella-taglie"]'));
    sizeChartLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
    });

    closeButtons.forEach(button => {
      button.addEventListener('click', closeModal);
    });

    if (overlay) {
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          closeModal();
        }
      });
    }

    // Gestisci cambio selezione dropdown
    if (dropdown) {
      dropdown.addEventListener('change', handleDropdownChange);
    }

    // Gestisci ESC
    document.addEventListener('keydown', handleEscape);
  }

  // Inizializza quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
